export { default } from './Switch';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Switch/index.js
// module id = 462
// module chunks = 121